import { ENVIRONMENT_TYPE } from "../constant/common";
import { environment } from "../constant/environment";
import { decryptData, encryptData } from "../utils/api/encryption";
import { consoleLog } from "../utils/consoleLog/consoleLog";

const CLEAR_STORAGE_KEY = "clearStorage";

export const setItemInLocalStorage = (key: string, value: any) => {
  try {
    if (environment === ENVIRONMENT_TYPE.LOCAL) {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } else {
      const encryptedValue = encryptData(value);
      localStorage.setItem(key, encryptedValue);
    }
  } catch (error) {
    consoleLog(`Failed to store item in localStorage: ${error}`);
  }
};

export const getItemFromLocalStorage = (key: string) => {
  try {
    const serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return null;
    }
    if (environment === ENVIRONMENT_TYPE.LOCAL) {
      return JSON.parse(serializedValue);
    } else {
      const decryptedData = decryptData(serializedValue);
      return decryptedData;
    }
  } catch (error) {
    consoleLog(`Failed to retrieve item from localStorage: ${error}`);
    return null;
  }
};

export const checkAndClearStorageIfNeeded = (): boolean => {
  const clearFlag = getItemFromLocalStorage(CLEAR_STORAGE_KEY);

  if (clearFlag !== "4") {
    localStorage.clear();
    setItemInLocalStorage(CLEAR_STORAGE_KEY, "4");
    return true;
  }

  return false;
};
